export default __webpack_public_path__ + "static/media/icon-next.0aa189db.svg";